module.exports = __webpack_public_path__ + "img/symmetry_en.7ef4883.jpg";